import { Serializable } from "../core/serializable";

export class Address implements Serializable<Address> {
  id!: number;
  state!: string;
  city!: string;
  address!: string;
  zipCode?: string;

  deserialize(json: any): Address {
    this.id = json.id;
    this.state = json.state;
    this.city = json.city;
    this.address = json.address;
    this.zipCode = json.zip_code;
    return this;
  }
}
